@if (promotionData != undefined) {
  @switch (promotionData.promotionType) {
    @case (ePromotionType.FreeProduct) {
      <div class="fw-bold">
        <span i18n="@@PromotionInfoFreeProductPrefix"
          >Order {{ promotionData.perQuantity }} {{ promotionData.perQuantityUnit | quantityUnitToString: false | lowercase }} and receive {{ promotionData.additionQuantity }}
          {{ promotionData.additionQuantityUnit | quantityUnitToString: false | lowercase }} of product
        </span>
        @if (additionalProductDescription != undefined) {
          <span i18n="@@PromotionInfoFreeProductDescriptionPrefix"></span>
          {{ additionalProductDescription }}
        }
        @if (additionalProductDescription == undefined) {
          <span i18n="@@PromotionInfoFreeProductNumberPrefix"></span>
          {{ promotionData.additionProductNumber }}
        }
        <span i18n="@@PromotionInfoFreeProductSuffix"> free</span>
      </div>
    }
    @case (ePromotionType.FreeInclusive) {
      <div class="fw-bold">
        <span i18n="@@PromotionInfoFreeInclusive"
          >Order {{ promotionData.perQuantity }} {{ promotionData.perQuantityUnit | quantityUnitToString: false | lowercase }} and receive {{ promotionData.additionQuantity }}
          {{ promotionData.additionQuantityUnit | quantityUnitToString: false | lowercase }} of them free</span
        >
      </div>
    }
    @case (ePromotionType.FreeExclusive) {
      <div class="fw-bold">
        <span i18n="@@PromotionInfoFreeExclusive"
          >Order {{ promotionData.perQuantity }} {{ promotionData.perQuantityUnit | quantityUnitToString: false | lowercase }} and receive {{ promotionData.additionQuantity }}
          {{ promotionData.additionQuantityUnit | quantityUnitToString: false | lowercase }} additionally free</span
        >
      </div>
    }
  }
}
